export const types = {
  SET_WIND_TURBINE_MODE: "SET_WIND_TURBINE_MODE",
  SET_PRECURSOR_CASE: "SET_PRECURSOR_CASE",

  SET_NZ_SETTING: "SET_NZ_SETTING",
  SET_NZ: "SET_NZ",
  SET_STRETCH_LEVEL: "SET_STRETCH_LEVEL",
  SET_STRETCH_FACTOR: "SET_STRETCH_FACTOR",
  SET_DZ_MAX: "SET_DZ_MAX",
  SET_HEIGHT_AUTO: "SET_HEIGHT_AUTO",

  SET_WIND_PROFILE_SETTINGS_MODE: "SET_WIND_PROFILE_SETTINGS_MODE",
  SET_U_COMPONENT_OF_GEOSTROPHIC_WIND: "SET_U_COMPONENT_OF_GEOSTROPHIC_WIND",
  SET_V_COMPONENT_OF_GEOSTROPHIC_WIND: "SET_V_COMPONENT_OF_GEOSTROPHIC_WIND",
  SET_HUB_HEIGHT: "SET_HUB_HEIGHT",
  SET_WIND_SPEED_AT_HUB_HEIGHT: "SET_WIND_SPEED_AT_HUB_HEIGHT",
  SET_WIND_DIRECTION_AT_HUB_HEIGHT: "SET_WIND_DIRECTION_AT_HUB_HEIGHT",
  SET_TEMPERATURE_PROFILE: "SET_TEMPERATURE_PROFILE",
  SET_SUBSTANCE_PROFILE: "SET_SUBSTANCE_PROFILE",

  SET_ROTOR_TABLE: "SET_ROTOR_TABLE",
  SET_ROTOR_SPEED: "SET_ROTOR_SPEED",
  SET_YAW_ANGLE: "SET_YAW_ANGLE",
  SET_ROTOR_PLANE_TILT_ANGLE: "SET_ROTOR_PLANE_TILT_ANGLE",
  SET_GENERATOR_RATED_MECHANICAL_POWER: "SET_GENERATOR_RATED_MECHANICAL_POWER",
  SET_ACTIVATE_SPEED_CONTROL: "SET_ACTIVATE_SPEED_CONTROL",
  SET_ACTIVATE_PITCH_CONTROL: "SET_ACTIVATE_PITCH_CONTROL",
  SET_ACTIVATE_YAW_CONTROL: "SET_ACTIVATE_YAW_CONTROL",
  SET_YAW_ACTUATOR_SPEED: "SET_YAW_ACTUATOR_SPEED",
  SET_DRAG_COEFFICIENT_TOWER: "SET_DRAG_COEFFICIENT_TOWER",
  SET_TANGENTIAL_LENGTH_OF_ROTOR_SEGMENTS:
    "SET_TANGENTIAL_LENGTH_OF_ROTOR_SEGMENTS",
  SET_RADIAL_WIDTH_OF_ROTOR_SEGMENTS: "SET_RADIAL_WIDTH_OF_ROTOR_SEGMENTS",
  SET_NUMBER_OF_AIRFOILS: "SET_NUMBER_OF_AIRFOILS",

  SET_ROUGHNESS_LENGTH_DOMAIN: "SET_ROUGHNESS_LENGTH_DOMAIN",
  SET_SURFACE_HEATFLUX: "SET_SURFACE_HEATFLUX",
  SET_RAYLEIGH_DAMPING_HEIGHT: "SET_RAYLEIGH_DAMPING_HEIGHT",
  SET_RAYLEIGH_DAMPENING_FACTOR: "SET_RAYLEIGH_DAMPENING_FACTOR",
  SET_INTERTIAL_OSCILLATION_DAMPENING_FACTOR:
    "SET_INTERTIAL_OSCILLATION_DAMPENING_FACTOR",
  SET_CANOPY_DRAG_COEFFICIENT: "SET_CANOPY_DRAG_COEFFICIENT",
  SET_WALL_HEATFLUX_TOP_SURFACE: "SET_WALL_HEATFLUX_TOP_SURFACE",

  SET_CORES_IN_X_DIRECTION: "SET_CORES_IN_X_DIRECTION",
  SET_CORES_IN_Y_DIRECTION: "SET_CORES_IN_Y_DIRECTION",
  SET_SIMULATION_DURATION: "SET_SIMULATION_DURATION",

  SET_NETCDF_DATA_FORMAT: "SET_NETCDF_DATA_FORMAT",
  SET_SKIP_TIME_BEFORE_DATA_OUTPUT: "SET_SKIP_TIME_BEFORE_DATA_OUTPUT",
  SET_TIME_INTERVAL_RUN_CONTROL_OUTPUT: "SET_TIME_INTERVAL_RUN_CONTROL_OUTPUT",
  SET_TIME_INTERVAL_DATA_OUTPUT: "SET_TIME_INTERVAL_DATA_OUTPUT",
  SET_TIME_INTERVAL_AVERAGE_DATA_OUTPUT:
    "SET_TIME_INTERVAL_AVERAGE_DATA_OUTPUT",
  SET_TIME_INTERVAL_TIMESERIES_OUTPUT: "SET_TIME_INTERVAL_TIMESERIES_OUTPUT",
  SET_TIME_INTERVAL_PROFILES_OUTPUT: "SET_TIME_INTERVAL_PROFILES_OUTPUT",
  SET_TIME_INTERVAL_3D_OUTPUT: "SET_TIME_INTERVAL_3D_OUTPUT",
  SET_AVERAGING_INTERVAL: "SET_AVERAGING_INTERVAL",
  SET_TIME_PERIOD_FOR_AVERAGING: "SET_TIME_PERIOD_FOR_AVERAGING",
  SET_AVERAGING_INTERVAL_FOR_PROFILES: "SET_AVERAGING_INTERVAL_FOR_PROFILES",
  SET_TIME_PERIOD_FOR_PROFILES_AVERAGING:
    "SET_TIME_PERIOD_FOR_PROFILES_AVERAGING",

  LOAD_WIND_TURBINE_SETTINGS: "LOAD_WIND_TURBINE_SETTINGS",
  LOAD_SAVED_WIND_TURBINE_SETTINGS: "LOAD_SAVED_WIND_TURBINE_SETTINGS",
  RESET_WIND_TURBINE_SETTINGS: "RESET_WIND_TURBINE_SETTINGS",

  SET_SECTION_YZ: "SET_SECTION_YZ",
  SET_SECTION_XZ: "SET_SECTION_XZ",
  SET_MASK_OVER_SURFACE: "SET_MASK_OVER_SURFACE",
  SET_MASK_TF_VLIMIT: "SET_MASK_TF_VLIMIT",

  // POI and Wind Turbine Data Management
  SET_WIND_TURBINE_POI_OPTIONS: "SET_WIND_TURBINE_POI_OPTIONS",
  SET_WIND_TURBINE_POI_SELECTED: "SET_WIND_TURBINE_POI_SELECTED",
  SET_WIND_TURBINE_WIND_TURBINE_OPTIONS: "SET_WIND_TURBINE_WIND_TURBINE_OPTIONS",
  SET_WIND_TURBINE_WIND_TURBINE_SELECTED: "SET_WIND_TURBINE_WIND_TURBINE_SELECTED",
  SET_WIND_TURBINE_DATA_LOADED: "SET_WIND_TURBINE_DATA_LOADED",
  SET_PRECURSOR_CASE_OPTIONS: "SET_PRECURSOR_CASE_OPTIONS",
};
